import { render, staticRenderFns } from "./AuthContainer.vue?vue&type=template&id=53bf821c&"
import script from "./AuthContainer.vue?vue&type=script&lang=ts&"
export * from "./AuthContainer.vue?vue&type=script&lang=ts&"
import style0 from "./AuthContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VFadeTransition,VLayout,VMain})
